import { useState } from 'react';
import { AppPage } from 'components/app-page/AppPage';
import CheckImport from '@pages/upload-pages/import-merchant/CheckImport';
import UploadFile from '@pages/upload-pages/import-merchant/UploadFile';



export const ImportMerchant = () => {

	const [ allowImport, setAllowImport ] = useState(false);

	return (
		<AppPage
			className='upload-page'
			pageLabel='Nahrávání souborů - Merchant'
		>
			<div className='upload-content'>	
				
				{allowImport === true &&
					<UploadFile uploadReset={() => setAllowImport(false)} />}

				{allowImport === false &&
					<CheckImport allowUpload={() => setAllowImport(true)}/>}

			</div>

		</AppPage>
	)
}

export default ImportMerchant;